<template>
  <div class="shuiyin">
    <i></i>
    <div class="companyName">{{companyName}}</div>
    <div class="nameAndTime">{{username}}: {{currentYMD()}}</div>
  </div>
</template>

<script>

export default {
  props: {
    position: {
      type: Object,
      default: () => ({})
    },
    markType: {
      type: String,
      default: 'cw_copyright'
    }
  },
  components: {},
  data () {
    return {
      open_copyright: false,
      timer: null,
      minute: 1,
      companyName: localStorage.getItem('_name'),
      username: localStorage.getItem('_username')
    }
  },

  mounted () {
    this.systemSetting()
  },
  methods: {
    async shuiyin () {
      $('.shuiyin').show()
      // $('.shuiyin:first').show()
      let _this = this
      let shuiyinW = $('.shuiyin').width()
      let shuiyinH = $('.shuiyin').height()
      let x = _this.position.x - shuiyinW
      let y = _this.position.y - shuiyinH
      _this.shuiyin2(x, y)

      // await _this.systemSetting().then(re => {
      _this.timer = setInterval(function () {
        _this.shuiyin2(x, y)
      }, _this.minute * 60 * 1000)
      // })
    },
    shuiyin2 (x, y) {
      let x1 = parseInt(Math.random() * (x + 1), 10)
      let y1 = parseInt(Math.random() * (y + 1), 10)
      // console.log('x1y1',x1,y1)
      $('.shuiyin').css({'left': x1, 'top': y1})
    },
    // 获取接口返回的几分钟水印换一次位置
    systemSetting () {
      // return new Promise((resolve, reject) => {
      let _this = this
      this.$axios.post('index.php/mobile/system-setting/values', {field_name: this.markType}).then(res => {
        if (res.data.code == 0 && JSON.stringify(res.data.result.list) != '{}') {
          _this.minute = parseInt(res.data.result.list[this.markType].cycle)
          _this.open_copyright = true
          _this.shuiyin()
          _this.currentYMD()
        } else {
          _this.open_copyright = false
        }
      })
      // let _this = this;
      // let url = "index.php/mobile/system-setting/values";
      // let params = {
      //   field_name:'cw_copyright',
      //   sys_id: localStorage.getItem("_sys_id"),
      //   company_id: localStorage.getItem("_user_data_company_id"),
      //   user_id: localStorage.getItem("_user_data_id"),
      //   sso_token: localStorage.getItem("_user_data_sso_token"),
      //   language: localStorage.getItem("_user_data_language"),
      //   client_version: "1.1.1"
      // };
      // _this.$axios.post(url, params).then(function(res) {
      //   // console.log('systemSetting',res);
      //   if (res.data.code == 0 && JSON.stringify(res.data.result.list.cw_copyright) != "{}") {
      //     // _this.programItem = res.data.result;
      //     _this.minute = res.data.result.list.cw_copyright.cycle
      //     resolve(_this.minute);
      //   } else {
      //     //_this.$message.error(_this.$t("public.DataError"));
      //   }
      // });
      // })
    },
    // 获取当前年月日
    currentYMD () {
      var myDate = new Date()
      let Y = myDate.getFullYear()
      let M = myDate.getMonth() + 1 < 10 ? '0' + (myDate.getMonth() + 1) : myDate.getMonth() + 1
      let D = myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate()
      return `${Y}.${M}.${D}`
    }

  },
  beforeDestroy () {
    // $('.shuiyin').hide();
    clearInterval(this.timer)
    this.timer = null
  }
}
</script>

<style scoped lang="less">
      .shuiyin{
        display:none;
        position:absolute;
        left:0;
        top:0;
        width:3.8rem;
        height:.68rem;
        text-align: left;
        pointer-events: none;
        // background:pink;
        // text-shadow:4px 2px 6px rgba(83, 79, 79, 0.55);
        // color: #ccc;
        color: red;
        text-shadow: -1px -1px 0 #fff,1px 1px 0 #333,1px 1px 0 #444;
        z-index:999999991;
        i{
          position:absolute;
          left:0.02rem;
          top:0.1rem;
          width:.08rem;
          height:.48rem;
          border-radius:0.06rem;
          background:rgba(255,255,255,0.6);
          box-shadow: -1px -1px 0 #fff,1px 1px 0 #333,1px 1px 0 #444;
        }
        .companyName{
          overflow:hidden;
          text-overflow:ellipsis;
          white-space:nowrap;
          width:100%;

          color:rgba(255,255,255,0.6);
          height:.3rem;
          line-height:.3rem;
          font-size:.26rem;
          font-weight: bold;
          padding-left:.25rem;
          margin-bottom:0.06rem;
        }
        .nameAndTime{
          overflow:hidden;
          text-overflow:ellipsis;
          white-space:nowrap;
          width:100%;
          color:rgba(255,255,255,0.6);
          height:.3rem;
          line-height:.3rem;
          font-size:.26rem;
          font-weight: bold;
          padding-left:.25rem;
        }
      }
</style>
